// frontend/src/components/ProtectedRoute/ProtectedRoute.js

import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getDemoSession } from '../../utils/mockAuth';

export default function ProtectedRoute() {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Verificar si hay sesión demo activa
    const session = getDemoSession();
    setIsAuthenticated(!!session);
    setIsChecking(false);
  }, []);

  // Mientras verifica, mostrar loading
  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
      </div>
    );
  }

  // Si no hay sesión, redirige al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si hay sesión, permite el acceso a las rutas protegidas
  return <Outlet />;
}